import React, { useState } from 'react'
import {
    Flex,
    PageWrapper,
    PageFooter,
    H1WithBack,
    HeadlineFlex,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { useSelector } from 'react-redux'
import { Pagination } from 'components/Pagination/Pagination'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearProvisioningRecords, getProvisioningRecords } from 'features/food/foodSlice'
import { NavBar } from 'components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { GenerateFoodRecordsModal } from './GenerateFoodRecordsModal'

export const ProvisioningRecords = () => {
    const { provisioningRecords } = useSelector((store: RootState) => store.food)
    const [params, setParams] = useState<any>(getParams({ location, limit: 30, ap: { date: new Date(), groupBy: 'supplier' } }))
    const [modal, setModal] = useState(false)
    const navigate = useNavigate()
    useQueryPagination({ fetchFunctions: [getProvisioningRecords], cleanUpFunctions: [clearProvisioningRecords], params })

    const filterOptions = [
        { label: 'Supplier', value: 'supplier' },
        { label: 'Meal Type', value: 'mealType' },
    ]

    const columns: IHonestTableColumn<any>[] = [
        { id: 'supplier', header: 'SUPPLIER', cell: (item) => item.foodSupplier?.name || '/' },
        { id: 'mealTypes', header: 'MEAL TYPES', cell: (item) => item.mealTypes.map(mt => mt.mealType?.name).join(', ') },
    ]

    return (
        <>
            <NavBar defaultValue={params.q} input placeholder='Search Records...' setParams={setParams} limit={30} />
            <PageWrapper>
                <HeadlineFlex between center mb='16' >
                    <H1WithBack arrow title='Provisioning Records' />
                    <Flex gap='1rem' alignEnd >
                        <HeadlineFlex gap='1rem' >
                            <Flex gap='1rem' alignEnd>
                                <CalendarInput nomarg width='200px' labelText='Date' onChange={date => setParams(prev => ({ ...prev, date }))} defaultValue={params.date} />
                                <HonestSelectInput noX width='200px' defaultValue={params.groupBy} nomarg labelText='Group By' options={filterOptions} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, groupBy: v.value }))} />
                            </Flex>
                            <Flex gap='1rem' alignEnd>
                                <Button variant='primary' style={{ width: '200px' }} onClick={() => navigate('standby')} >Stand By Provisioning</Button>
                                <Button variant='primary' style={{ width: '200px' }} onClick={() => navigate('ad-hoc')} >Ad Hoc Provisioning</Button>
                                <Button variant='primary' style={{ width: '200px' }} onClick={() => setModal(true)} >Generate Records</Button>
                            </Flex>
                        </HeadlineFlex>

                    </Flex>
                </HeadlineFlex>
                {!provisioningRecords?.data?.length ? (
                    <NoItems title='Records' />
                ) : (
                    <HonestTable columns={columns} data={(provisioningRecords.data || []).map((r, i) => ({ ...r, id: i }))} keyField='id' />
                )}
                {modal && <GenerateFoodRecordsModal closeModal={() => setModal(false)} />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(provisioningRecords.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
